var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxiSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00CEFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462,241.6l-22-84.8c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.7-14.3-32-32-32H192c-17.7,0-32,14.3-32,32v32 h-11.2c-35.2,0-67.2,25.6-76.8,60.8l-22,84.8C21.4,248,0,273.5,0,304v48c0,23.6,12.9,44,32,55.1V448c0,17.7,14.3,32,32,32h32 c17.7,0,32-14.3,32-32v-32h256v32c0,17.7,14.3,32,32,32h32c17.7,0,32-14.3,32-32v-40.9c19-11.1,32-31.5,32-55.1v-48 C512,273.5,490.6,248,462,241.6z M96,352c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S113.7,352,96,352z M116.6,240 l17.2-66.4c2.2-8.2,9.6-13.6,15.1-13.6h214.4c5.5,0,12.8,5.5,14.9,12.9l17.4,67.1H116.6L116.6,240z M416,352c-17.7,0-32-14.3-32-32 s14.3-32,32-32s32,14.3,32,32S433.7,352,416,352z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiSolid);
export default __webpack_public_path__ + "static/media/taxi-solid.09beed5da4fd29c658fb2fefd54d3f3f.svg";
export { ForwardRef as ReactComponent };